import React, { useEffect, useState } from 'react';
import { Col, Label, Row } from 'reactstrap';
import axios from "axios";
import Swal from "sweetalert2";
import ConfigData from "../../config.json";
import "../../assets/scss/pages/_assign-work.scss";
import DownloadPDF from '../common/pdf-download';
import { setStringFileNameToArray } from '../utils/format-value';
import MultipleDownloadfile from '../common/multiple-downloadfile';
import { IconLoading } from "../common/popup-alert";

const AssignDetailPoa = ({ requestDetail, requestTemplateDetail }) => {
    const accessToken = localStorage.getItem("tkd");
    const [requestType, setRequestType] = useState([]);
    const [purposePoaDoc, setPurposePoaDoc] = useState([]);
    const [attorneyDoc, setAttorneyDoc] = useState([]);
    const [detailPoaDoc, setDetailPoaDoc] = useState([]);
    const [formOtherPoaDoc, setFormOtherPoaDoc] = useState([]);
    const [userDetail, setUserDetail] = useState({
        "id": 0,
        "id_business_unit": 0,
        "id_user_group": 0,
        "email": "",
        "name": "",
        "surname": "",
        "business_unit": "",
        "department": "",
        "user_group": "",
        "status": ""
    });
    const [userCoordinate, setUserCoordinate] = useState({
        "id": 0,
        "id_business_unit": 0,
        "id_user_group": 0,
        "email": "",
        "name": "",
        "surname": "",
        "business_unit": "",
        "department": "",
        "user_group": "",
        "status": ""
    });
    

    useEffect(() => {
        if(requestDetail.id > 0 && requestTemplateDetail.id > 0){
            showLoading(true);
            LoadRequestType(requestTemplateDetail.id_request_type);            
            if(requestDetail.create_request_by !== "" && requestDetail.create_request_by !== null){
                LoadUserInfo(requestDetail.create_request_by, setUserDetail);
                LoadUserInfo(requestDetail.request_by, setUserCoordinate);
            }else{
                LoadUserInfo(requestDetail.request_by, setUserDetail);
            }
            setPurposePoaDoc(setStringFileNameToArray(requestTemplateDetail.purpose_poa_doc));
            setAttorneyDoc(setStringFileNameToArray(requestTemplateDetail.attorney_doc));
            setDetailPoaDoc(setStringFileNameToArray(requestTemplateDetail.detail_poa_doc));
            setFormOtherPoaDoc(setStringFileNameToArray(requestTemplateDetail.form_other_poa_doc));
            showLoading(false);
        }
    }, [requestDetail, requestTemplateDetail]);

    const showLoading = (isShow) => {
        if (isShow) {
            Swal.fire({
                iconHtml: IconLoading,
                title: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                willOpen: () => {
                Swal.showLoading();
                },
            });
        } else {
            Swal.close();
        }
    };

    const LoadRequestType = (requestTypeId) => {
        if (typeof requestTypeId === "undefined" || requestTypeId === null) {
            return;
        }
        let url = ConfigData.API_URL + "request-type/" + requestTypeId;
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + accessToken,
            },
            responseType: "json",
        }).then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                setRequestType(respData.data[0]);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const LoadUserInfo = (email, setValue) => {
        let url = ConfigData.API_URL + "user/search?email=" + email;
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + accessToken,
            },
            responseType: "json",
        }).then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                console.log(respData.data[0]);
                setValue(respData.data[0]);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    return (
        <React.Fragment>
            <Row>
                <Col xl={12} className="mx-auto">
                    <DownloadPDF fileName={`form-poa-${requestDetail.request_no}.pdf`} type={"formLabel"} >
                        <div className="page-content-assign">
                            <Row id="section-page-1-1">
                                <Col md={12}>
                                    <Row>
                                        <Col md={10}>
                                        <div className="header-content">
                                            ข้อมูลของผู้ทำคำขอ (User Information)
                                        </div>
                                        </Col>
                                        <Col md={2}>
                                        <div id="section-page-hide-input" className="header-form">
                                            <span>
                                            <Label htmlFor="export-pdf" className="form-export-file-label">
                                                <i className="mdi mdi-upload i-upload"></i>
                                                Export
                                            </Label>
                                            </span>
                                        </div>
                                        </Col>
                                    </Row>
                                    <div className="dashed-line"></div>
                                    <Row>
                                        <Col md={6}>
                                        <div className="body-content">
                                            <Label className="content-name">
                                                คำขอเลขที่ (Request No.)
                                            </Label>
                                            <Label className="content-val">
                                                {requestDetail.request_no || "-"}
                                            </Label>
                                        </div>
                                        </Col>
                                        <Col md={6}>
                                        <div className="body-content">
                                            <Label className="content-name">
                                                วันที่สร้างคำขอ (Date of Request)
                                            </Label>
                                            <Label className="content-val">
                                                {requestDetail.request_date || "-"}
                                            </Label>
                                        </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                        <div className="body-content">
                                            <Label className="content-name">
                                                ผู้ทำคำขอ (User’s Request)
                                            </Label>
                                            <Label className="content-val">
                                                {userDetail.name + " " + userDetail.surname || "-"}
                                            </Label>
                                        </div>
                                        </Col>
                                        <Col md={6}>
                                        <div className="body-content">
                                            <Label className="content-name">
                                                อีเมลผู้ทำคำขอ (User’s email)
                                            </Label>
                                            <Label className="content-val">
                                                {userDetail.email || "-"}
                                            </Label>
                                        </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                        <div className="body-content">
                                            <Label className="content-name">
                                                บริษัทที่สังกัด (User's BU)
                                            </Label>
                                            <Label className="content-val">
                                                {userDetail.business_unit || "-"}
                                            </Label>
                                        </div>
                                        </Col>
                                        <Col md={6}>
                                        <div className="body-content">
                                            <Label className="content-name">
                                                แผนกที่สังกัด (User's Department)
                                            </Label>
                                            <Label className="content-val">
                                                {userDetail.department || "-"}
                                            </Label>
                                        </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {(requestDetail.create_request_by !== "" && requestDetail.create_request_by !== null) ? (
                                <Row id="section-page-1-2">
                                    <Col md={12}>
                                        <div className="header-content">
                                            ข้อมูลของผู้ประสานงานกลาง (User Coordinator Information)
                                        </div>
                                        <div className="dashed-line"></div>
                                        <Row>
                                            <Col md={6}>
                                                <div className="body-content">
                                                    <Label className="content-name">
                                                        ผู้ประสานงานกลาง (Name of User Coordinator)
                                                    </Label>
                                                    <Label className="content-val">
                                                        {userCoordinate.name + " " + userCoordinate.surname || "-"}
                                                    </Label>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="body-content">
                                                    <Label className="content-name">
                                                        อีเมลผู้ประสานงาน (Coordinator’s Email)
                                                    </Label>
                                                    <Label className="content-val">
                                                        {userCoordinate.email || "-"}
                                                    </Label>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <div className="body-content">
                                                    <Label className="content-name">
                                                        บริษัทที่สังกัด (User's BU)
                                                    </Label>
                                                    <Label className="content-val">
                                                        {userCoordinate.business_unit || "-"}
                                                    </Label>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="body-content">
                                                    <Label className="content-name">
                                                        แผนกที่สังกัด (User's Department)
                                                    </Label>
                                                    <Label className="content-val">
                                                        {userCoordinate.department || "-"}
                                                    </Label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            ) : null}
                            <Row id="section-page-1-3">
                                <Col md={12}>
                                    <div className="header-content">
                                        ข้อมูลทั่วไป (Request General Information)
                                    </div>
                                    <div className="dashed-line"></div>
                                    <Row>
                                        <Col md={12}>
                                            <div className="body-content">
                                                <Label className="content-name">ประเภทคำขอ (Type of Request)</Label>
                                                <Label className="content-val">
                                                {requestType.name_en || "-"}
                                                </Label>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row id="section-page-2-1">
                                <Col md={12}>
                                    <div className="header-content">
                                        ข้อมูลเอกสาร (Request Form Information)
                                    </div>
                                    <div className="dashed-line"></div>
                                    <Row>
                                        <Col md={12}>
                                            <div className="body-content">
                                                <Label className="content-name">วัตถุประสงค์ที่ต้องการหนังสือมอบอำนาจ (Purpose of this Power of Attorney (POA)</Label>
                                                <Label className="content-val">
                                                    {requestTemplateDetail.purpose_poa || "-"}
                                                </Label>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row id="section-page-2-2">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ไฟล์เอกสารต้นเรื่องที่ต้องการมอบอำนาจ  (The document for which the power of attorney is required)
                                        </Label>
                                        {purposePoaDoc.length > 0 ? (
                                            <MultipleDownloadfile
                                                folder={requestDetail.request_no}
                                                dataFile={purposePoaDoc}
                                            />
                                        ) : (
                                            <div>-</div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-3">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            วันทำหนังสือมอบอำนาจ(Date of Power of Attorney)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.date_poa || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-4">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            เหตุผลที่ไม่สามารถลงวันที่เป็นปัจจุบันได้ (the reason for this necessity)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.date_poa_reason || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-5">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ทำหนังสือมอบอำนาจในนามของ (Company Name)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.name_businessunit || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-6">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ชื่อผู้มอบอำนาจ (Name of the Grantor)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.grantor || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-7">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ชื่อผู้รับมอบอำนาจ (Name of the Attorney)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.attorney || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-8">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ไฟล์สำเนาบัตรประชาชนของผู้รับมอบอำนาจ  (Attach attach a copy of the ID card for each attorney)
                                        </Label>
                                        {attorneyDoc.length > 0 ? (
                                            <MultipleDownloadfile
                                                folder={requestDetail.request_no}
                                                dataFile={attorneyDoc}
                                            />
                                        ) : (
                                            <div>-</div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-9">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            จำนวนคนและเงื่อนไขการดำเนินการของผู้รับมอบอำนาจ (Number and conditions of Attorney)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.attorney_number_condition || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-10">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            มอบอำนาจให้ดำเนินการใดบ้าง (Details)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.detail_poa || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-11">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ตัวอย่างหนังสือมอบอำนาจที่เคยจัดทำแล้วหรือมีแบบฟอร์มหนังสือมอบอำนาจหรือเนื้อหาที่มอบอำนาจ
                                        </Label>
                                        {detailPoaDoc.length > 0 ? (
                                            <MultipleDownloadfile
                                                folder={requestDetail.request_no}
                                                dataFile={detailPoaDoc}
                                            />
                                        ) : (
                                            <div>-</div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-12">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ระยะเวลาของหนังสือมอบอำนาจ (The duration of the POA)
                                        </Label>
                                        <Label className="content-val">
                                            {(requestTemplateDetail.duration_poa_type !== "" && requestTemplateDetail.duration_poa_type !== null) ? ((requestTemplateDetail.duration_poa_type === "1") ? "ใช้หนังสือมอบอำนาจเพียงครั้งเดียว" : "ใช้แบบมีระยะเวลา" ) : "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-13">
                                <Col md={6}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            วันที่เริ่มต้น (Commencement Date)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.duration_poa_start_date || "-"}
                                        </Label>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            วันที่สิ้นสุด (Expiry Date)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.duration_poa_end_date || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-14">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ระบุเหตุผลความจำเป็นที่ให้วันเริ่มต้นมีผลบังคับย้อนหลัง (please also provide the reason for this necessity)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.duration_poa_reason || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-15">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            พยาน (Witness)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.witness || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-16">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            แบบฟอร์มและเอกสารอื่น ๆ ที่ต้องกรอกและใช้ยื่นเรื่องพร้อมกับหนังสือมอบอำนาจ <br />
                                            (Forms and other documents that must be completed along with the POA)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.form_other_poa || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-17">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            เอกสารแนบ (Attachment)
                                        </Label>
                                        {formOtherPoaDoc.length > 0 ? (
                                            <MultipleDownloadfile
                                                folder={requestDetail.request_no}
                                                dataFile={formOtherPoaDoc}
                                            />
                                        ) : (
                                            <div>-</div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-2-18">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            เอกสารประกอบอื่น ๆ (นอกเหนือจากชุดหนังสือมอบอำนาจ) ที่ขอจากฝ่ายกฎหมาย <br/>
                                            (Other supporting documents required from Legal Team)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.other_support_doc || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-3-1">
                                <Col md={12}>
                                    <div className="header-content">
                                        เอกสารประกอบหนังสือมอบอำนาจ (Supporting documents to the POA) 
                                    </div>
                                    <div className="dashed-line"></div>
                                    <div className="sub-header-content">
                                        หนังสือรับรองบริษัท (Company Affidavit)
                                    </div>
                                    <Row>
                                        <Col md={12}>
                                            <div className="body-content">
                                                <Label className="content-name">
                                                    ฝ่ายกฎหมายจะให้หนังสือรับรองบริษัทอายุไม่เกิน 6 เดือน นับแต่วันที่ทำหนังสือมอบอำนาจ
                                                </Label>
                                                <Label className="content-val">
                                                    {(requestTemplateDetail.company_affidavit_type !== "" && requestTemplateDetail.company_affidavit_type !== null) ? ((requestTemplateDetail.company_affidavit_type === "1") ? "หนังสือรับรองน้อยกว่า 6 เดือน" : "หนังสือรับรองมากกว่า 1 ฉบับ") : "-"}
                                                </Label>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row id="section-page-3-2">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ระบุจำนวนและ เหตุผลหากต้องการมากกว่า 1 ฉบับ (Please specify if needed more than 1 copy)
                                        </Label>
                                        <Label className="content-val">
                                            {(requestTemplateDetail.company_affidavit_type === "1") ? (requestTemplateDetail.company_affidavit_age || "-") : (requestTemplateDetail.company_affidavit_reason || "-")}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-3-3">
                                <Col md={12}>
                                    <div className="sub-header-content">
                                        บัตรประชาชนและ/หรือทะเบียนบ้านผู้มอบอำนาจ (ID Card and/or House Registration of the Grantor)
                                    </div>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            เอกสารของผู้มอบอำนาจ
                                        </Label>
                                        <Label className="content-val">
                                            {(requestTemplateDetail.req_idcard_houseregis_type !== "" && requestTemplateDetail.req_idcard_houseregis_type !== null) ? ((requestTemplateDetail.req_idcard_houseregis_type === "1") ? "บัตรประชาชน" : "บัตรประชาชนและทะเบียนบ้าน") : "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-3-4">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            จำนวน
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.req_idcard_houseregis_amount || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-3-5">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            เหตุผลหากต้องการมากกว่า 1 ฉบับ
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.req_idcard_houseregis_reason || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-4-1">
                                <Col md={12}>
                                    <div className="header-content">
                                        อื่นๆ (Others)
                                    </div>
                                    <div className="dashed-line"></div>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ข้อมูลอื่น ๆ (Other information)
                                        </Label>
                                        <Label className="content-val">
                                            {requestTemplateDetail.other_info || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-4-2">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ชื่อนักกฎหมายที่เคยตรวจเอกสารนี้ (Legal team who has handled this work)
                                        </Label>
                                        <Label className="content-val">
                                            {requestDetail.require_handled_by || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row id="section-page-4-3">
                                <Col md={12}>
                                    <div className="body-content">
                                        <Label className="content-name">
                                            ผู้อนุมัติแบบคำขอ (User Approver)
                                        </Label>
                                        <Label className="content-val">
                                            {requestDetail.approve_request_by || "-"}
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </DownloadPDF>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default AssignDetailPoa;